// extracted by mini-css-extract-plugin
export default {"auth-loader":"AuthenticationLoader_auth-loader__+InHQ","loader":"AuthenticationLoader_loader__xkd-X","spin":"AuthenticationLoader_spin__-xyot"};